module.exports = __webpack_public_path__ + "img/svip.2b4a8a8b.svg";